import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { PaymentVaComponent } from './payment-va.component';
import { RegistrationPaymentVaComponent } from './registration-payment-va/registration-payment-va.component';
import { PaymentAccumulationSetupComponent } from './payment-accumulation-setup/payment-accumulation-setup.component';

const routes: Routes = [
  {
    path: '',
    component: PaymentVaComponent,
    children: [
      {
        path: '',
        component: RegistrationPaymentVaComponent
      },
      {
        path: 'accumulation-setup',
        component: PaymentAccumulationSetupComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentVaRoutingModule {
}
